import auth from './auth'
import event from './event'
import provider from './provider'

export default {
	auth,
	event,
	provider
}
